import { useMemo, useState } from 'react';

import { DEFAULT_RESUME_SORT_ID, getResumeSortOrder } from '../ResumeSearch.constants';

export const useResumeSort = () => {
  const [sortId, setSortId] = useState(DEFAULT_RESUME_SORT_ID);

  const order = useMemo(() => getResumeSortOrder(sortId), [sortId]);

  return { sortId, order, setSortId };
};
